import { Component, OnInit } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Noticia } from 'src/app/models/noticia.model';

@Component({
  selector: 'app-financas',
  templateUrl: './financas.component.html',
  styleUrls: ['./financas.component.css']
})
export class FinancasComponent implements OnInit {

  public noticias : Noticia[]
  
  constructor(ns: NoticiasService)
  {
      ns.getNoticiasFinancas()
      .subscribe((dados: Noticia[]) => this.noticias = dados);
  }

  ngOnInit(): void {
  }

}
